/*
 * ---------------------------------------------------------------------------------
 * Copyright:
 *      NewtonGreen Technologies Pty. Ltd.
 *      Level 4, 175 Scott St.
 *      Newcastle, NSW, 2300
 *      Australia
 * 
 *      E-mail: support@newtongreen.com
 *      Tel: (02) 4925 5288
 *      Fax: (02) 4925 3068
 * 
 *      All Rights Reserved.
 * ---------------------------------------------------------------------------------
 */

/*
 * --------------------------------------------------------------------------------
 * This file contains the base layout for the favourites view.
 * --------------------------------------------------------------------------------
 */

/*
 * ---------------------------------------------------------------------------------
 * Imports - External
 * ---------------------------------------------------------------------------------
 */

/**
 * Required to make use of JSX functionality
 */
import * as React from 'react';

/**
 * Utility used to generate a Hook to allow for the creation of styles using JSS.
 */
import { makeStyles } from '@material-ui/core/styles';

/**
 * Material UI Paper component.
 */
import Paper from '@material-ui/core/Paper';

/**
 * Material UI Typography component.
 */
import { Typography } from '@material-ui/core';

/*
 * ---------------------------------------------------------------------------------
 * Styles
 * ---------------------------------------------------------------------------------
 */

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3, 2),
    margin: theme.spacing(3, 0)
  },
}));

/*
 * ---------------------------------------------------------------------------------
 * Components
 * ---------------------------------------------------------------------------------
 */

const Favourites: React.FunctionComponent = ({

}) => {
    const classes = useStyles();

    return (
        <Paper
            className={classes.paper}
        >
            <Typography
                variant="h1"
            >
                Favourites
            </Typography>
            <Typography
                variant="body1"
            >
                Some text
            </Typography>
        </Paper>
    );
};

/*
 * ---------------------------------------------------------------------------------
 * Exports - Default
 * ---------------------------------------------------------------------------------
 */

export default Favourites;


// WEBPACK FOOTER //
// ./src/containers/Favourites.tsx